module.exports = __webpack_public_path__ + "img/12.cacd0e73.png";